(ns minorodata.ai-chat.model
  (:require [mold.core :as m :include-macros true]))

(declare ->ai-settings)

(m/defmodel ai-settings
  {:client-id       [::m/string "Client id"]

   :assistant-enaled [::m/bool "If assistant is enabled or not"]
   :mcp-enabled [::m/bool "If external MCP client access is enabled or not"]
   :db-metadata-access [::m/bool "Access to database metadata: schemas, table structure, etc."]
   :db-data-sampling [::m/bool "If AI can fetch data from the database"]
   :db-raw-data-sampling [::m/bool "If AI can access data from the database without intermediate obfuscation"]

   :byol-enabled [::m/bool "If the tenant's own LLM provider keys are in use"]
   :byol-effective [::m/bool "If a validated default provider and model are set, so KAI is actually using them"]
   :default-provider [::m/string ::m/nilable "Default BYOL provider"]
   :default-model [::m/string ::m/nilable "Default BYOL model"]
   :allow-user-model-selection [::m/bool "If users may pick from the approved models per conversation"]
   :approved-models [::m/vector ::m/nilable "Models users may pick from, as {:provider :model}"]
   :credential-versions [::m/map ::m/nilable "Per-provider credential version numbers"]}
  {:singleton true})
